import {Platform, StyleSheet} from 'react-native';

import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  wrapper: {
    padding: 5,
  },
  cardsRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  card: {
    padding: 20,
    borderWidth: 1,
    borderColor: 'black',
    borderRadius: 5,
    margin: Platform.OS === 'web' ? 15 : 4,
    minWidth: 250,
  },
  skeletonHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  skeletonTitle: {
    height: 20,
    width: '70%',
    backgroundColor: cloudLight,
    borderRadius: 4,
  },
  skeletonIcon: {
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: cloudLight,
  },
  skeletonValue: {
    height: 30,
    width: '30%',
    backgroundColor: cloudLight,
    borderRadius: 4,
    marginBottom: 20,
  },
  skeletonTextSmall: {
    height: 20,
    width: '90%',
    marginBottom: 10,
  },
  skeletonDivider: {
    height: 1,
    width: '100%',
    backgroundColor: 'lightgray',
    marginBottom: 20,
  },
  skeletonRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 40,
  },
  skeletonRowSmall: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10, // Added for flexibility
  },
  skeletonLabel: {
    height: 25,
    width: '60%',
  },
  skeletonValueSmall: {
    height: 25,
    width: 40,
  },
  skeletonFooterRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});
